import 'core-js/es/promise';
import 'core-js/es/array';
import 'core-js/es/string';
import 'core-js/es/object';
import 'core-js/es/number';
import 'core-js/es/symbol/iterator';
import 'core-js/stable/url-search-params';
import 'regenerator-runtime/runtime';
import extend from 'extend';

import type { App as AppImport } from './App';
import type AppInstanceType from './commons/types/AppInstanceType';
import type ConfigType from './commons/types/ConfigType';

type AppFn = typeof AppImport;

const builder = {
    defaultConfiguration: {} as Partial<ConfigType>,

    onReady(callback: () => void) {
        callback();
    },

    extendDefaultConfig(customConfig: Partial<ConfigType>) {
        extend(true, this.defaultConfiguration, customConfig);
    },

    build(options: Partial<ConfigType>): AppInstanceType {
        const configuration = extend(true, {}, this.defaultConfiguration, options) as ConfigType;

        // eslint-disable-next-line @typescript-eslint/no-require-imports
        const { App } = require('./App') as { App: AppFn };
        return App(configuration);
    },
};

export default builder;
